export function responseIsCurrent({ connected = true, requestId, latestRequestId } = {}) {
  return !!connected && requestId === latestRequestId
}
